import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { monetate } from '@grandvisionhq/svc-monetate';
import { pushPdpEventToDataLayer } from '../../../DataLayer/data-layer.js';
import { useProductDetailContext } from '../../Context/ProductDetailContext.js';

/**
 * This component triggers the top, page-level analytics for the product detail page.
 * It is a component instead of a hook so that it can more easily consume data from the ProductDetailContext
 * in any REST-based PDP template
 * @returns null
 */ const ProductDetailPageAnalytics = ()=>{
    const { currency  } = useIntl();
    const { isMonetateProductDataEnabled  } = useFeatureToggles();
    const { activeSku , product  } = useProductDetailContext();
    const { id: productId  } = product;
    React.useEffect(()=>{
        // Trigger generic data layer event on page load
        DataLayer.pushPageTypeToDataLayer('product detail');
    }, []);
    React.useEffect(()=>{
        // Trigger data layer events for the active variant
        pushPdpEventToDataLayer(DataLayer.DataLayerTypes.PurchaseType.OneTime, product, activeSku, currency);
        // Trigger Monetate events
        monetate().trackProductDetail(isMonetateProductDataEnabled ? [
            {
                sku: activeSku,
                productId
            }, 
        ] : []);
    }, [
        activeSku
    ]);
    return null;
};

export { ProductDetailPageAnalytics };
//# sourceMappingURL=ProductDetailPageAnalytics.js.map
